/**
 * @flow
 *
 * @format
 */
import App from './App';

export default App;
